import { axiosServiceInstance } from '../axios';

export type TPresignedUploadResponse = { uploadUrl: string; publicUrl: string | null };

/**
 * Request a presigned R2 upload URL.
 *
 * `sizeBytes` is required, not optional: the server checks it against the
 * caller's per-file ceiling and signs it into the URL as `Content-Length`, so R2
 * refuses a body of any other length. That pairing is the entire size guarantee,
 * and it only holds if every caller declares a size — hence a positional
 * argument the compiler enforces rather than an optional field to forget.
 *
 * `durationSeconds` (videos only) lets the server reject an over-length clip
 * before the upload starts. Browser-measured and trusted.
 */
export const getPresignedUploadUrl = async (
  key: string,
  contentType: string,
  sizeBytes: number,
  options?: { folder?: string; durationSeconds?: number },
): Promise<TPresignedUploadResponse> => {
  const res = await axiosServiceInstance.get<TPresignedUploadResponse>('/upload/presigned-url', {
    params: {
      key,
      contentType,
      sizeBytes,
      ...(options?.folder && { folder: options.folder }),
      ...(options?.durationSeconds !== undefined && { durationSeconds: options.durationSeconds }),
    },
  });
  return res.data;
};
